{
    "SSO_Login_Title": "Eenmalige aanmelding (SSO)",
    "SSO_Login_Description": "Even geduld, gebruikersgegevens worden gevalideerd. Dit zou niet lang moeten duren.",
    "SSO_Login_Error": "Sorry, we kunnen u niet vinden. Probeer het opnieuw. Als dit probleem zich blijft voordoen, neem dan contact op met uw applicatiebeheerder.",
    "SSO_MissingCode_Error": "Sorry, er ging iets mis. Probeer het opnieuw. Als dit probleem zich blijft voordoen, neem dan contact op met uw applicatiebeheerder.",
    "NAME": "SSOLanguage"
}